export function isPlainObject(item: any): item is Record<string, any> {
  return (
    Object.prototype.toString.call(item) === '[object Object]' &&
    (item.constructor === Object || item.constructor === undefined)
  );
}

export function deepMergeCore<
  T extends Record<string, any>,
  U extends Record<string, any>,
>(target: T, source: U) {
  target = { ...target };
  for (const key in source) {
    const targetValue = target[key];
    const sourceValue = source[key];
    if (isPlainObject(targetValue) && isPlainObject(sourceValue)) {
      target[key] = deepMergeCore(targetValue, sourceValue);
    } else {
      target[key] = sourceValue as any;
    }
  }
  return target as U & T;
}

export function deepMerge<T extends Record<string, any>, U>(target: T, source: U) {
  if (isPlainObject(target) && isPlainObject(source)) {
    return deepMergeCore(target, source);
  }
  return target;
}
export function safeJson<T>(string: string, defaultValue: T) {
  try {
    return JSON.parse(string) as T;
  } catch (_) {
    return defaultValue;
  }
}
